import React, { PureComponent } from 'react';
import TablaAjusteCargoMotivoRow from './TablaAjusteCargoMotivoRow';

class TablaAjusteCargoMotivo extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { movimientosFiltradosParaMostrarPanel, destildarTildarCheckFiltroAjusteCargo } = this.props;

        return (
            <div>
                <table className={"noBorder modal-filtros-tabla-ajuste-cargo-motivo modalLogIntentosScroll"}>
                    <tbody>
                        <TablaAjusteCargoMotivoRow destildarTildarCheckFiltroAjusteCargo={destildarTildarCheckFiltroAjusteCargo} movimientosFiltradosParaMostrarPanel={movimientosFiltradosParaMostrarPanel}/> 
                    </tbody>
                </table>
            </div>
        );
    }
}

export default TablaAjusteCargoMotivo;
